module.exports = __webpack_public_path__ + "img/oil-gas-finder.fe771f2d.svg";